<template>
  <div class="row">
    <!-- SALDO TOKEN -->
    <div class="col-md-4 mb-4 d-flex flex-column">
      <status-card
        iconClass="fa fa-database"
        label="Saldo Token AI"
        :value="formatNumber(balance)"
      />
      <!-- <div class="dashboard-card card border-0 shadow-sm h-100">
        <div class="card-body d-flex align-items-center">

          <div class="icon-circle bg-soft-warning mr-3">
            <i class="fa fa-database"></i>
          </div>

          <div class="text-right flex-fill">
            <div class="metric-value">
              {{ formatNumber(balance) }}
            </div>
            <div class="metric-label">
              Saldo Token AI
            </div>
          </div>

        </div>
      </div> -->
    </div>

    <!-- STATUS AI -->
    <div class="col-md-4 mb-4 d-flex flex-column">
      <status-card
        iconClass="fa fa-power-off"
        label="Status AI"
        :labelClass="isActive ? 'text-success' : 'text-danger'"
        :value="isActive ? 'Aktif' : 'Nonaktif'"
      />
      <!-- <div class="dashboard-card card border-0 shadow-sm h-100">
        <div class="card-body d-flex align-items-center">
          <div
            class="icon-circle mr-3"
            :class="isActive ? 'bg-soft-success' : 'bg-soft-danger'"
          >
            <i :class="isActive ? 'fa fa-check' : 'fa fa-power-off'"></i>
          </div>

          <div class="text-right flex-fill">
            <div
              class="metric-value"
              :class="isActive ? 'text-success' : 'text-danger'"
            >
              {{ isActive ? "Aktif" : "Nonaktif" }}
            </div>
            <div class="metric-label">Status AI</div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- TOKEN DIGUNAKAN -->
    <div class="col-md-4 mb-4 d-flex flex-column">
      <status-card
        iconClass="fa fa-line-chart"
        label="Token Digunakan" 
        labelClass="d-flex flex-column"
        :value="formatNumber(used)"
      >  
      <template #label>
        Token Digunakan <br>
        <router-link :to="'/ai/pricing'" class="badge badge-primary">Topup</router-link>
      </template>
      </status-card>
      <!-- <div class="dashboard-card card border-0 shadow-sm h-100">
        <div class="card-body d-flex align-items-center">
          <div class="icon-circle bg-soft-primary mr-3">
            <i class="fa fa-line-chart"></i>
          </div>

          <div class="text-right flex-fill">
            <div class="metric-value text-primary">
              {{ formatNumber(used) }}
            </div>
            <div class="metric-label">Token Digunakan</div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- KNOWLEDGE BASE SHORTCUT -->
    <div class="col-md-4 mb-4 d-flex flex-column">
      <div
        class="dashboard-card card border-0 shadow-sm h-100 cursor-pointer"
        @click="$emit('manage-knowledge')"
      >
        <div class="card-body d-flex align-items-center">
          <div class="icon-circle bg-soft-info mr-3">
            <i class="fa fa-book"></i>
          </div>

          <div class="text-right flex-fill">
            <div class="metric-value text-info">Kelola</div>
            <div class="metric-label">Knowledge Base</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusCard from "./StatusCard.vue";
export default {
  name: "ChatAIDashboardCards",
  components: {
    StatusCard,
  },
  props: {
    balance: {
      type: Number,
      default: 0,
    },
    used: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatNumber(val) {
      if (!val) return "0";
      if (val >= 1000) {
        return (val / 1000).toFixed(0) + "K";
      }
      return val.toString();
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  /* border-radius: 12px; */
  transition: 0.2s ease;
}

/* .dashboard-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
} */

.metric-value {
  font-size: 24px;
  font-weight: 700;
}

.metric-label {
  font-size: 13px;
  color: #6c757d;
}

.icon-circle {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}

/* Soft Background Variants */
.bg-soft-warning {
  background: #f3e3d3;
  color: #f39c12;
}

.bg-soft-success {
  background: #e6f4ea;
  color: #28a745;
}

.bg-soft-danger {
  background: #fdecea;
  color: #dc3545;
}

.bg-soft-primary {
  background: #e7f1ff;
  color: #007bff;
}

.bg-soft-info {
  background: #e3f8ff;
  color: #17a2b8;
}

.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/chat/overview/Status.vue